module.exports = __webpack_public_path__ + "static/media/7.0e56ce2f.svg";